<template>
  <div class="tab-list">
    <div
      class="tab-item"
      :key="tab.id"
      @click="select(tab)"
      :class="{ select: tab.select, hide: tab.hide }"
      v-for="tab in tabList"
    >
      <div>{{ tab.text }}</div>
    </div>
    <div class="operation-container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "SettingManagerTab",
  props: {
    tabList: {
      type: Array,
      required: true,
    },
  },
  methods: {
    /**
     * tab点击选中事件
     * @param item
     */
    select(item) {
      // 清空其他选中(单选)
      this.tabList.forEach((tab) => {
        tab.select = false;
      });
      item.select = true;
    },
  },
};
</script>
<style scoped lang="less">
.tab-list {
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  justify-content: space-between;
  .tab-item {
    height: 44px;
    border-bottom: 2px solid transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 130px;
    padding: 0 10px;
    color: #8c8c8c;
    font-size: 16px;
    cursor: pointer;
    margin-right: 20px;
    &:hover {
      opacity: 0.7;
    }

    &.select {
      border-bottom-color: black;
      color: black;
    }
    &.hide {
      display: none;
    }
  }
  .operation-container {
    flex: 1;
    justify-content: flex-end;
  }
}
</style>
